/** Imports */
import { loadingstyle } from './style.css.js';
import { saveCartAndCurrency } from './model.js';

/** Initialization */
const discountSVG = require('./assets/discount.svg.js').discountSVG;
const crossSVG = require('./assets/cross.svg.js').crossSVG;

/** Internal functions */
function findAnchor(anchor) {
  const anchorElements = document.querySelectorAll(anchor);
  console.dlog('Anchor elements', anchorElements);
  return anchorElements;
}

function listenForAnchor(anchor, settings, processDiscountFunction) {
  // If no checkoutbutton was found, create a mutation observer to check if cartpage is added dynamically
  let mutationObserver = new MutationObserver(() => {
    // TODO: check if there is already a discount field at the desired position
    const anchorElements = findAnchor(anchor);
    // const discountFields = document.querySelectorAll(
    //   '#dcodeOuterWrapper',
    // );
    anchorElements.forEach(anchorElement => {
      const anchorParent = anchorElement.parentElement;
      const discountField =
        anchorParent &&
        anchorParent.querySelector('#dcodeOuterWrapper');
      if (anchorElement && !discountField) {
        console.dlog('dcode - Anchor found!', anchor);
        mutationObserver.disconnect();
        let currentDiscount = sessionStorage.getItem(
          'currentDiscount',
        );
        currentDiscount = currentDiscount
          ? JSON.parse(currentDiscount)
          : undefined;
        initialFormSetup(
          settings,
          processDiscountFunction,
          currentDiscount,
          anchorElement,
        );
        mutationObserver.observe(document.documentElement, {
          childList: true,
          subtree: true,
        });
      }
    });
  });
  // Starts listening for changes in the root HTML element of the page.
  mutationObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

function initialFormSetup(
  settings,
  processDiscountFunction,
  existingDiscount,
  anchorElement,
) {
  const { config, labels } = settings;
  const {
    classes,
    style,
    location = 'beforeend',
    automaticStyle,
    customSubtotal,
    additionalStyle,
  } = config;

  // Create stylesheet for discount buttons
  const styleElement = document.createElement('style');
  styleElement.innerHTML = formatStylesheet(style);
  styleElement.id = 'dcodeCustomStyle';
  const existingStyle = document.getElementById('dcodeCustomStyle');
  if (existingStyle) existingStyle.remove();
  document.getElementsByTagName('head')[0].appendChild(styleElement);

  // Create dcodeForm from template
  const wrapper = document.createElement('div');
  wrapper.innerHTML = formTemplate(classes, labels, automaticStyle);
  const dcodeForm = wrapper.firstElementChild;

  // Insert dcodeForm at the desired location
  anchorElement.insertAdjacentElement(location, dcodeForm);

  linkProcessDiscountFunction(processDiscountFunction);

  // If existing discount, add info box
  if (existingDiscount) {
    const { title } = existingDiscount;
    // Tell the processDiscountFunction that it's an existing discount,
    // therefore only display it if it's valid
    processDiscountFunction(
      title,
      null,
      null,
      null,
      true,
      'INITIAL FORM SETUP',
    );
  }

  // Update the discount if value of subtotal changes
  listenForSubtotalChanges(customSubtotal, processDiscountFunction);
  addAdditionalStylesheet(additionalStyle, 'dcAdditionalStyle');
}

function findNextInput(element) {
  if (element) {
    while (!element.classList.contains('dcodeInnerWrapper')) {
      element = element.parentElement;
    }
    return element.querySelector('#dcodeInput');
  }
}

function linkProcessDiscountFunction(processDiscountFunction) {
  console.dlog('Linking process discount function');
  // Add processDiscount function to dcodeButton and inputField
  const dcodeSubmitList = document.querySelectorAll('#dcodeSubmit');
  dcodeSubmitList.forEach(dcodeSubmit => {
    const newSubmit = dcodeSubmit.cloneNode(true);
    dcodeSubmit.parentNode.replaceChild(newSubmit, dcodeSubmit);
    newSubmit.addEventListener('click', event => {
      event.preventDefault();
      console.dlog('Event', event);
      const inputfield = findNextInput(event.srcElement);
      const code =
        // eslint-disable-next-line eqeqeq
        inputfield && inputfield.value != null
          ? inputfield.value.trim()
          : undefined;
      processDiscountFunction(
        code,
        inputfield,
        null,
        null,
        null,
        'CLICK EVENT',
      );
    });
  });
  const dcodeInputList = document.querySelectorAll('#dcodeInput');
  dcodeInputList.forEach(dcodeInput => {
    const newInput = dcodeInput.cloneNode(true);
    dcodeInput.parentNode.replaceChild(newInput, dcodeInput);
    newInput.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        event.preventDefault();
        console.dlog('Event', event);
        const inputfield = findNextInput(event.srcElement);
        const code = inputfield ? inputfield.value : undefined;
        processDiscountFunction(
          code,
          inputfield,
          null,
          null,
          null,
          'ENTER EVENT',
        );
      }
    });
  });
}

function formatStylesheet(style) {
  const { outerWrapper, innerWrapper, input, button } = style || {};
  return `${loadingstyle} 
	div#dcodeOuterWrapper {${outerWrapper}}
	div#dcodeInnerWrapper {${innerWrapper}}
	input#dcodeInput {${input}}
	button#dcodeSubmit {${button}}`;
}

/**
 * Returns the HTML for the discount field box
 * @param {Object} classes Custom classes
 * @param {Object} labels Custom labels on input and button
 * @param {Boolean} automaticStyle If custom style is enabled, classes of checkout button and update button are added
 */
function formTemplate(classes, labels, automaticStyle) {
  const { outerWrapper, innerWrapper, input, button } = classes || {};
  const { inputlabel, buttonlabel } = labels || {};
  let {
    checkoutClassList,
    updateClassList,
    checkoutParentClassList,
  } = getCheckoutClasses(automaticStyle);
  const disabled = document.querySelector('.hulkapps-cart-total')
    ? 'disabled'
    : '';
  const disabledNotice =
    disabled === 'disabled' ? '<p>Volume discount active</p>' : '';
  return `
	<div id="dcodeOuterWrapper" class="dcodeOuterWrapper dcSmooth ${outerWrapper}">
		<div id="dcodeInnerWrapper" class="${checkoutParentClassList} dcodeInnerWrapper dcSmooth ${innerWrapper}">
			<input 
				id="dcodeInput"
				class="${updateClassList} dcodeInput dcSmooth ${input}" 
				placeholder="${inputlabel || 'Discount'}"
				value=""
				${disabled}
			>
			<button id="dcodeSubmit" class="${checkoutClassList} dcodeButton dcSmooth ${button} " type="button" ${disabled}>
				<span id="dcodeButtonLabelPlaceholder">${buttonlabel ||
          'Apply'}</span>
				<span id="dcodeButtonLabel" style="opacity: 1;">${buttonlabel ||
          'Apply'}</span>
				<div id="dcodeLoading" class="dcloading"></div>
			</button>
			${automaticStyle ? '<div class="dc-clearfix-100"></div>' : ''}
		</div>
		${disabledNotice}
	</div>
	`;
}

function getCheckoutClasses(automaticStyle) {
  if (!automaticStyle)
    return {
      checkoutClassList: '',
      updateClassList: '',
      checkoutParentClassList: '',
    };
  const checkoutButton = getButton('checkout');
  const updateButton = getButton('update') || checkoutButton;
  const checkoutParent = checkoutButton
    ? checkoutButton.parentElement
    : undefined;
  const checkoutClassList = checkoutButton
    ? checkoutButton.classList.toString()
    : '';
  const updateClassList = updateButton
    ? updateButton.classList.toString()
    : '';
  const checkoutParentClassList = checkoutParent
    ? checkoutParent.classList.toString()
    : '';
  return {
    checkoutClassList,
    updateClassList,
    checkoutParentClassList,
  };
}

function infoBoxTemplate(
  title,
  subtotal,
  currency,
  value,
  restriction,
  calcActive,
  labels,
) {
  let {
    subtotal: customSubtotalLabel,
    discount: customDiscountLabel,
    total: customTotalLabel,
    language,
  } = labels || {};

  let subtotalLabel, discountLabel, totalLabel;
  switch (language) {
    case 'french':
      subtotalLabel = 'Sous-total';
      discountLabel = 'Livraison';
      totalLabel = 'Total';
      break;
    case 'german':
      subtotalLabel = 'Zwischensumme';
      discountLabel = 'Discount';
      totalLabel = 'Summe';
      break;
    default:
      subtotalLabel = 'Subtotal';
      discountLabel = 'Discount';
      totalLabel = 'Total';
  }
  subtotalLabel = customSubtotalLabel || subtotalLabel;
  discountLabel = customDiscountLabel || discountLabel;
  totalLabel = customTotalLabel || totalLabel;

  // Create restriction field (if existing)
  const discountRestriction = restriction
    ? `<tr>
		<td colspan='2' class='dcRestriction'>${restriction}</td>
	</tr>`
    : '';

  // Display discount value or loading icon
  value =
    value === null || isNaN(value)
      ? value
      : Math.floor(Math.abs(value.toFixed(4)) * 100) / 100; // 'Round down' like shopify
  const discountTable =
    value !== null && value !== undefined
      ? `<div class='dc-clearfix'></div>
		<table class='dcSmooth dcodeTable'>
			<tr class="dcodeSubtotal dcode-subtotal-row">
				<td class='dcode-subtotal-label'>${subtotalLabel}</td>
				<td>
					<span class='money'>
            <span class='dcode-currency dcode-subtotal-currency'>
              ${currency}
            </span>
            <span class='dcode-subtotal-value'>
              ${subtotal.toFixed(2)}
            </span>
					</span>
				</td>
			</tr>
			<tr class='dcode-discount-row'>
        <td class='dcode-discount-label'>
          <span class='dcode-discount-label-static'>${discountLabel}</span>
          <span class='dcode-discount-label-dynamic'>${title}</span>
        </td>
				<td class='dcode-discount-value-cell'>
					${
            isNaN(value)
              ? value
              : '<span class="money">-&nbsp;<span class="dcode-currency dcode-discount-currency">' +
                currency +
                '</span><span class="dcode-discount-value">' +
                value.toFixed(2) +
                '</span></span>'
          }
				</td>
			</tr>
			<tr class='dcodeTotal dcode-total-row'>
				<td class='dcode-total-label'>${totalLabel}</td>
				<td class='dcodeTotalValue dcode-total-value'>
					<span class='money'>
					  <span class='dcode-currency dcode-total-currency'>${currency +
              '</span><span class="dcode-total-value">' +
              (isNaN(value)
                ? subtotal
                : Math.max(subtotal - value, 0)
              ).toFixed(2) +
              '</span>'}
					</span>
				</td>
			</tr>
			${discountRestriction}
		</table>`
      : `<div class="loading-wrapper"><div class="dcloading loading-dark"></div></div>`;

  // Return the full template
  return `
	<div id='dcodeInfo' class='dcSmooth'>
		<div class='dcSmooth dcDiscountBox'>
			<svg id='tags-filled' class='dcIcon'>${discountSVG}</svg>
			<p>${title}</p>
			<button type='button' id='removeDiscount' focusable='false'>
				${crossSVG}
			</button>
		</div>
		${
      calcActive
        ? discountTable
        : "<div class='dc-clearfix'></div><span class='calcNotice'>Total calculated at checkout</span>"
    }
	</div>`;
}

function getButton(name) {
  let button = document.querySelector('input[name="' + name + '"]');
  if (!button)
    button = document.querySelector('button[name="' + name + '"]');
  if (!button)
    button = document.querySelector('a[href="/' + name + '"]');
  return button;
}

function createHiddenDiscountFields(cartforms, title) {
  // Create hidden field for currently active discount
  let dcodeValidDiscount = document.createElement('input');
  dcodeValidDiscount.id = 'dc_valid_discount';
  dcodeValidDiscount.setAttribute('type', 'hidden');
  dcodeValidDiscount.setAttribute('name', 'discount');

  cartforms.forEach(cartform => {
    cartform.insertAdjacentElement('afterbegin', dcodeValidDiscount);
    if (title) dcodeValidDiscount.value = title;
    dcodeValidDiscount = dcodeValidDiscount.cloneNode();
  });
}

function updateHiddenDiscount(title, customCartform) {
  if (!title) title = '';
  if (!customCartform) customCartform = "form[action*='/cart']";
  console.dlog('updateHiddenDiscount(', title, ')');

  // check if multiple cartforms exist. If so, add a hidden discount to all of them
  const cartforms = document.querySelectorAll(customCartform);
  if (cartforms && cartforms.length > 1) {
    // if there is more than 1 cartform, delete all hidden discount fields and recreate them
    document
      .querySelectorAll('input[name="discount"]')
      .forEach(e => e.remove());
    createHiddenDiscountFields(cartforms, title);
  } else if (cartforms.length === 1) {
    const cartform = cartforms[0];
    // check if there is a hidden discount field already in the cartform.
    const existingInputFields = cartform.querySelectorAll(
      'input[name="discount"]',
    );
    // if there is none, create one
    if (existingInputFields.length === 0) {
      createHiddenDiscountFields(cartforms, title);
      // set a timeout and then update the value
      setTimeout(() => {
        const input = document.querySelector(
          'input[name="discount"]',
        );
        const value = input ? input.value : undefined;
        if (title !== value) {
          console.dlog('Refreshing discount field with', title);
          document
            .querySelectorAll('input[name="discount"]')
            .forEach(e => {
              e.value = title;
              console.dlog(
                'Setting value of ',
                e,
                'to',
                title,
                '(again)',
              );
            });
        }
      }, 1500);
    }

    // Set the value imediately and after 1.5 seconds again with the current value
    document.querySelectorAll('input[name="discount"]').forEach(e => {
      e.value = title;
      console.dlog('Setting value of ', e, 'to', title);
    });
  }

  // now there should be at least one hidden discount field in the cart
  // Setting the value of all hidden input fields with the name discount to the value of the current discount

  // Support for cart apps
  const atc_calc = document.getElementById('atc_calc_cartjson');
  if (atc_calc) {
    document
      .querySelectorAll('input[name=atc_calcc_discountinput]')
      .forEach(e => {
        e.remove();
      });
    const atc_discount = document.createElement('input');
    atc_discount.value = title;
    atc_discount.setAttribute('type', 'hidden');
    atc_discount.setAttribute('name', 'atc_calcc_discountinput');
    atc_calc.insertAdjacentElement('afterend', atc_discount);
  }
  // Save the current discount code as a cookie, like Shopify does it internally
  //window.setCookie('discount_code', title);
}

/** Exported functions */
/**
 * Starts a Mutation observer, that listens for changes in the custom subtotal element.
 * Only starts when custom Subtotal element is found.
 * @param {string} customSubtotal: CSS Selector of custom subtotal element
 * @param {function} handleDiscount: Function that is called when a new subtotal is found
 */
export async function listenForSubtotalChanges(
  customSubtotal,
  handleDiscount,
) {
  console.dlog(
    'Listening for changes in customSubtotal',
    customSubtotal,
  );
  if (customSubtotal) {
    let mutationObserver = new MutationObserver(mutations => {
      console.dlog('Change in subtotal detected', mutations);
      const selfUpdate = sessionStorage.getItem('updatingSubtotal');
      if (selfUpdate) {
        console.dlog('It was a selfupdate. Doing nothing.');
        return;
      }
      const newElement = document.querySelector(customSubtotal);
      const oldContent = sessionStorage.getItem('dcSubtotalElement');
      if (newElement.innerHTML === oldContent) {
        console.dlog('The content did not change. Doing nothing');
        return;
      }
      sessionStorage.setItem(
        'dcSubtotalElement',
        newElement.innerHTML,
      );
      const currentDiscountString = sessionStorage.getItem(
        'currentDiscount',
      );
      const currentDiscount = currentDiscountString
        ? JSON.parse(currentDiscountString).title
        : undefined;
      if (currentDiscount) handleDiscount(currentDiscount);
    });
    // Starts listening for changes in the parent of custom Subtotal
    let element = document.querySelector(customSubtotal);
    if (element) {
      console.dlog('Start listening for subtotal change on', element);
      sessionStorage.setItem('dcSubtotalElement', element.innerHTML);
      mutationObserver.observe(element, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }
}

export function discountBoxExisting() {
  return !!document.querySelector('.dcodeOuterWrapper');
}

/**
 * Checks for anchor element on page. If existing, discount field is added.
 * If not, Mutation observer checks for changes (for ajax carts)
 * @param {classes: obj, labels: obj, style: obj, anchor: string} settings
 * @param {function} processDiscountFunction
 */
export function setupForm(
  settings,
  processDiscountFunction,
  existingDiscount,
  ignoreHiddenAnchor,
) {
  // Setup custom integration if existing
  const customIntegration = document.getElementById(
    'dcodeOuterWrapper',
  );
  const setupWizard = localStorage.getItem('dcodeSetupSettings');
  if (customIntegration && !setupWizard) {
    console.dlog('Custom integration found');
    linkProcessDiscountFunction(processDiscountFunction);
    // If existing discount, add info box
    // if (existingDiscount) {
    // 	const { error, title, value, restriction } = existingDiscount;
    // 	updateCart(error, title, value, restriction, settings);
    // }
  }

  // Setup new discount box locations
  const { anchor } = settings.config;
  const anchorElements = findAnchor(anchor);
  console.dlog(anchorElements);
  anchorElements.forEach(anchorElement => {
    console.dlog(
      'dcode - Anchor found',
      anchorElement,
      'Existing discount: ',
      existingDiscount,
    );
    initialFormSetup(
      settings,
      processDiscountFunction,
      existingDiscount,
      anchorElement,
    );
  });
  // Listen for eventually appearing new anchors
  console.dlog('dcode - Listening for appearing anchor:', anchor);
  if (!ignoreHiddenAnchor)
    listenForAnchor(
      anchor,
      settings,
      processDiscountFunction,
      existingDiscount,
    );
}

export function hideLoadingSymbol() {
  console.dlog('Hide loading symbol.');
  if (!discountBoxExisting()) return;
  document.querySelectorAll('#dcodeButtonLabel').forEach(el => {
    el.style.opacity = 1;
  });
  document.querySelectorAll('#dcodeLoading').forEach(el => {
    el.style.opacity = 0;
  });
}

export function displayLoadingSymbol() {
  if (!discountBoxExisting()) return;
  document.querySelectorAll('#dcodeButtonLabel').forEach(el => {
    el.style.opacity = 0;
  });
  document.querySelectorAll('#dcodeLoading').forEach(el => {
    el.style.opacity = 1;
  });
  console.dlog('Display loading symbol.');
}

export function removeAllErrorMessages() {
  document
    .querySelectorAll('.dcodeErrorMessage')
    .forEach(e => e.remove());
}

export function insertErrorMessage(message, dcodeInput) {
  // Remove previous messages
  removeAllErrorMessages();

  // Find input box if not already given
  if (!dcodeInput) dcodeInput = document.getElementById('dcodeInput');
  if (!message) message = 'Enter a valid discount code';

  const template = `<p class="dcodeErrorMessage">${message}</p>`;

  // Create the element from the template
  const wrapper = document.createElement('div');
  wrapper.innerHTML = template;
  const errorBox = wrapper.firstElementChild;
  dcodeInput.insertAdjacentElement('beforebegin', errorBox);
}

function triggerCurrencySwitch() {
  console.dlog('Calling triggerCurrencySwitch');
  try {
    if (
      typeof window.ACSCurrency !== 'undefined' &&
      typeof window.ACSCurrency.moneyFormats !== 'undefined'
    ) {
      window.mlvedaload();
    }
  } catch (e) {
    console.dlog(e);
  }
}

export async function updateCart(
  error,
  title,
  value,
  restriction,
  settings,
  dcodeInput,
  originalAmount,
  whoami,
) {
  console.dlog(
    'Updating cart with',
    title,
    value,
    settings,
    whoami ? 'I AM ' + whoami : '',
  );
  if (!discountBoxExisting()) return;
  if (!dcodeInput) dcodeInput = document.getElementById('dcodeInput');
  if (error) {
    // Display red border
    if (dcodeInput) dcodeInput.classList.add('dcInvalidCode');

    // Display error message
    const { labels: { errorMessage } = {} } = settings || {};
    insertErrorMessage(errorMessage, dcodeInput);
  } else {
    if (dcodeInput) dcodeInput.classList.remove('dcInvalidCode');
    removeAllErrorMessages();

    // Initialize valiables
    const { calcActive, config, labels, shopname: shop } = settings;
    let {
      infoboxAnchor: anchor,
      infoboxLocation: location,
      discountActiveStyle,
      customCartform,
      changeSubtotal,
      customSubtotal,
      additionalSubtotalSelector,
    } = config;
    if (!anchor) anchor = '.dcodeInnerWrapper';
    if (!location) location = 'beforeend';
    const currency = sessionStorage.getItem('currency');

    let subtotal = originalAmount;
    if (!subtotal) {
      let cart = JSON.parse(sessionStorage.getItem('cart'));
      if (!cart) {
        cart = await saveCartAndCurrency(customSubtotal, shop);
      }
      subtotal = cart && cart.total_price / 100;
    }

    // Create infoBox from template
    const wrapper = document.createElement('div');
    wrapper.innerHTML = infoBoxTemplate(
      title,
      subtotal,
      currency,
      value,
      restriction,
      calcActive,
      labels,
    );
    const infoBox = wrapper.firstElementChild;

    // Insert infoBox at the desired location
    const oldBoxes = document.querySelectorAll('#dcodeInfo');
    oldBoxes.forEach(b => b.remove());
    const anchorElements = findAnchor(anchor);
    anchorElements.forEach(anchorElement => {
      const infoBoxCopy = infoBox.cloneNode(true);
      anchorElement.insertAdjacentElement(location, infoBoxCopy);
    });

    updateSubtotal(
      changeSubtotal,
      customSubtotal,
      value,
      additionalSubtotalSelector,
    );

    addAdditionalStylesheet(discountActiveStyle, 'dcActiveStyle');

    // Add clear-discount function
    let removeButtons = document.querySelectorAll('#removeDiscount');
    console.dlog('Remove button: ', removeButtons);
    removeButtons.forEach(b => {
      b.addEventListener('click', clearDiscount);
      console.dlog('EVENT LISTENER ADDED', b);
    });

    // Set discountvalue of hidden field
    updateHiddenDiscount(title, customCartform);

    if (value && whoami !== 'NOT UPDATING') {
      // Dispatch event for integration into other apps
      if (
        navigator.userAgent.indexOf('MSIE') !== -1 ||
        navigator.appVersion.indexOf('Trident/') > 0
      ) {
        var evt = document.createEvent('UIEvents');
        evt.initUIEvent('discountAdded', true, false, window, 0);
        window.dispatchEvent(evt);
      } else {
        dispatchEvent(
          new CustomEvent('discountAdded', {
            title,
            value,
            restriction,
            originalAmount,
          }),
        );
      }
    }
  }

  // Compatibility wit AutoCurrencySwitcher
  triggerCurrencySwitch();
}

function updateSubtotal(
  changeSubtotal,
  customSubtotal,
  value,
  additionalSubtotalSelector,
) {
  console.dlog('updating subtotal', changeSubtotal, customSubtotal);
  const valueIsNumber = !(value === null || isNaN(value));
  if (changeSubtotal) {
    if (valueIsNumber) {
      const newSubtotalElem = document.querySelector(
        '.dcodeTotalValue',
      );
      const oldSubtotalElem = document.querySelector(customSubtotal);
      console.dlog(
        'Updating custom subtotal',
        newSubtotalElem,
        oldSubtotalElem,
        value,
      );
      sessionStorage.setItem('updatingSubtotal', 'true');
      if (newSubtotalElem && oldSubtotalElem) {
        document
          .querySelectorAll('#dcodeNewSubtotal')
          .forEach(e => e.remove());

        let oldSubtotalElements = [
          ...document.querySelectorAll(additionalSubtotalSelector),
        ];
        oldSubtotalElements.push(oldSubtotalElem);

        // Loop over all subtotal elements to update them
        oldSubtotalElements.forEach(oldSubtotal => {
          let newSubtotalElement = oldSubtotal.cloneNode();
          // Sometimes there is trouble when a span is inside a span.
          // Therefore, if parent is a span, create an inline div instead
          if (newSubtotalElement.nodeName === 'SPAN') {
            newSubtotalElement = document.createElement('div');
            newSubtotalElement.classList.add(
              ...oldSubtotal.classList,
              'dcInline',
            );
          }
          newSubtotalElement.classList.remove(
            'dcodeAbsoluteTransparent',
            'dcodeOldSubtotal',
          );
          newSubtotalElement.innerHTML = `
              <span class='dcodeLineThrough money'>${oldSubtotal.innerHTML}</span>
              <br />
              <span class='money'>${newSubtotalElem.innerHTML}</span>
              `;
          newSubtotalElement.id = 'dcodeNewSubtotal';
          oldSubtotal.classList.add(
            'dcodeAbsoluteTransparent',
            'dcodeOldSubtotal',
          );
          oldSubtotal.insertAdjacentElement(
            'afterend',
            newSubtotalElement,
          );
          console.dlog(
            'Inserted new subtotal element: ',
            newSubtotalElement,
          );
        });
      }
      sessionStorage.removeItem('updatingSubtotal');
    }
    document
      .querySelectorAll('.dcodeTotal, .dcodeSubtotal')
      .forEach(e => {
        e.style.display = 'none';
      });
  } else {
    console.dlog('removing classes');
    document
      .querySelectorAll(
        '.dcodeOldSubtotal, .dcodeAbsoluteTransparent',
      )
      .forEach(e => {
        e.classList.remove('dcodeOldSubtotal');
        e.classList.remove('dcodeAbsoluteTransparent');
      });
    document
      .querySelectorAll('#dcodeNewSubtotal')
      .forEach(e => e.remove());
  }
}

function addAdditionalStylesheet(css, id) {
  const elem = id ? document.getElementById(id) : undefined;
  if (!elem && css) {
    const style = document.createElement('style');
    style.innerHTML = css;
    style.id = id;
    document
      .querySelector('head')
      .insertAdjacentElement('beforeend', style);
  }
}

export function clearDiscount(event) {
  if (event) event.preventDefault();
  console.dlog(event);
  if (event && !(event.screenX === 0 && event.screenY === 0)) {
    console.dlog('removing discount');
    updateHiddenDiscount();
    const infoboxes = document.querySelectorAll('#dcodeInfo');
    infoboxes.forEach(box => {
      box.remove();
    });
    const currentStyles = document.querySelectorAll('#dcActiveStyle');
    currentStyles.forEach(s => {
      s.remove();
    });

    // remove discount cookie
    window.setCookie('discount_code', '');

    // remove custom subtotal
    document
      .querySelectorAll('#dcodeNewSubtotal')
      .forEach(e => e.remove());
    document
      .querySelectorAll('.dcodeOldSubtotal')
      .forEach(e =>
        e.classList.remove(
          'dcodeAbsoluteTransparent',
          'dcodeOldSubtotal',
        ),
      );
    sessionStorage.removeItem('currentDiscount');
    dispatchEvent(new Event('discountRemoved'));
  } else {
    console.dlog('Not removing the discount');
  }
  return false;
}
